import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VBtn,{attrs:{"icon":"","dark":""},on:{"click":_vm.handleClick}},[_c(VIcon,[_vm._v("mdi-view-grid-outline")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }